import { type RequestOptions, clientPanich } from "../client.panich";
import { type operations } from "../client.panich/schema";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /logger/save-cookie-jar
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type SaveCookieJarOperation = operations["save_cookies_logger_save_cookie_jar_post"];
export type SaveCookieJarProps = SaveCookieJarOperation["requestBody"]["content"]["application/json"];
export type SaveCookieJarReturn = SaveCookieJarOperation["responses"]["200"]["content"]["application/json"];

export const saveCookieJar = async (
  props: SaveCookieJarProps,
  requestOptions?: RequestOptions,
): Promise<SaveCookieJarReturn> => {
  const { ...body } = props;

  const { data } = await clientPanich.POST(
    `/logger/save-cookie-jar`,
    {
      body,
      credentials: "include",
      ...requestOptions,
    },
  );
  return data;
};
